export type TTemplateTagsFilterOptions = { [k: string]: { text: string, value: string }[] }


export enum ELogErrorMsg {
    //Bee Editor
    ErrorGettingBeeToken = "Error getting bee token",
    ErrorReloadingBeeEditor = "Error reloading bee editor",
    ErrorOnBrandingToggle = "Error onBrandingToggle",

    //Lists
    ErrorFetchingLists = "Error fetching lists",

    //Forms
    ErrorPublishingForm = "Error publishing form",
    ErrorCreatingForm = "Error creating form",
    ErrorSavingForm = "Error saving form",
    ErrorGettingForm = "Error getting form",
    ErrorFetchingForm = "Error fetching form",

    //Popups
    ErrorPublishingPopup = "Error publishing popup",
    ErrorCreatingPopup = "Error creating popup",
    ErrorSavingPopup = "Error saving popup",
    ErrorGettingPopup = "Error getting popup",

    //Pages
    ErrorPublishingPage = "Error publishing page",
    ErrorCreatingPage = "Error creating page",
    ErrorSavingPage = "Error saving page",
    ErrorGettingPage = "Error getting page",
    ErrorFetchingPage = "Error fetching page",

    //Zendesk
    ZendeskSupportNotEnabled = "Zendesk support is not enabled, missing help url",

    //Utils
    AccountIdForStoredFilters = "An Account id is required to get stored filters",
}